module.exports = function (coord, stdPitch) {
  if (typeof coord === 'number') {
    stdPitch = coord;
    return function (coord) {
      return stdPitch * Math.pow(2, (coord[0] * 12 + coord[1] * 7) / 12);
    };
  }

  stdPitch = stdPitch || 440;
  return stdPitch * Math.pow(2, (coord[0] * 12 + coord[1] * 7) / 12);
};